<template>
  <div class="shadow-fixed show">
    <div class="mask"></div>
    <div class="lgDetails-box">
      <div class="lgDetails-small-close"
           @click="$emit('closeLgD')"></div>
      <div class="lgDetails-scroll-box">
        <div class="lgDetails-inner">
          <div class="lgDetails-status">
            <el-steps align-center
                      :active="dataObj.OrderState"
                      finish-status="success">
              <el-step title="下单"></el-step>
              <el-step title="负责人确定"></el-step>
              <el-step title="中心领导确定"></el-step>
              <el-step v-if="dataObj.OnetimesOffPayback"
                       title="分管领导确定"></el-step>
              <el-step v-if="dataObj.TwotimesOffPayback"
                       title="总经理确定"></el-step>
              <el-step title="协理确定"></el-step>
            </el-steps>
            <!-- <div class="process">
              <div class="circle"></div>
              <div class="line"
                   :style="dataObj.OrderState == 1 ? {background:'#e7e7e7'} : ''"></div>
              <div class="circle"
                   :style="dataObj.OrderState == 1 ? {background:'#e7e7e7'} : ''"></div>
              <div class="line"
                   :style="dataObj.OrderState < 3 ? {background:'#e7e7e7'} : ''"></div>
              <div class="circle"
                   :style="dataObj.OrderState < 3 ? {background:'#e7e7e7'} : ''"></div>
              <div v-if="dataObj.OnetimesOffPayback"
                   class="line"
                   :style="dataObj.OrderState < 4 ? {background:'#e7e7e7'} : ''"></div>
              <div v-if="dataObj.OnetimesOffPayback"
                   class="circle"
                   :style="dataObj.OrderState < 4 ? {background:'#e7e7e7'} : ''"></div>
              <div v-if="dataObj.TwotimesOffPayback"
                   class="line"
                   :style="dataObj.OrderState < 5 ? {background:'#e7e7e7'} : ''"></div>
              <div v-if="dataObj.TwotimesOffPayback"
                   class="circle"
                   :style="dataObj.OrderState < 5 ? {background:'#e7e7e7'} : ''"></div>
              <div class="line"
                   :style="dataObj.OrderState < 6 ? {background:'#e7e7e7'} : ''"></div>
              <div class="circle"
                   :style="dataObj.OrderState < 6 ? {background:'#e7e7e7'} : ''"></div>
            </div>
            <div class="text">
              <p :style="dataObj.OrderState == 1 ? {color:'#4ecc92'} : ''">下单</p>
              <p :style="dataObj.OrderState == 2 ? {color:'#4ecc92'} : dataObj.OrderState == 1 ? {color:'#999'} : '' ">负责人确定</p>
              <p :style="dataObj.OrderState == 3 ? {color:'#4ecc92'} : dataObj.OrderState == 1 ? {color:'#999'} : '' ">中心领导确定</p>
              <p v-if="dataObj.OnetimesOffPayback"
                 :style="dataObj.OrderState == 4 ? {color:'#4ecc92'} : dataObj.OrderState == 1 ? {color:'#999'} : '' ">分管领导确定</p>
              <p v-if="dataObj.TwotimesOffPayback"
                 :style="dataObj.OrderState == 5 ? {color:'#4ecc92'} : dataObj.OrderState == 1 ? {color:'#999'} : '' ">总经理确定</p>
              <p :style="dataObj.OrderState == 6 ? {color:'#4ecc92'} : dataObj.OrderState < 7 ? {color:'#999'} : '' ">协理确定</p>
            </div> -->

          </div>
          <div class="lgDetails-content">
            <div>
              <p>项目名称</p>
              <p>{{dataObj.EntryName}}</p>
            </div>
            <div>
              <p>合同号</p>
              <p>{{dataObj.ContractNumber}}</p>
            </div>
            <div v-for="(Product) of dataObj.OrderProductModels"
                 :key="Product.ProName"
                 class="orderProduct">
              <div>
                <p>产品料号</p>
                <p>{{Product.ProLiaoNum}}</p>
              </div>
              <div>
                <p>产品名称</p>
                <p>{{Product.ProName}}</p>
              </div>
              <div>
                <p>数量</p>
                <p>{{Product.Number}}</p>
              </div>
              <div>
                <p>单位</p>
                <p>{{Product.NameEntity}}</p>
              </div>
            </div>
            <div>
              <p>收货地址</p>
              <p>{{dataObj.ReceivingAddress}}</p>
            </div>
            <div>
              <p>收货人</p>
              <p>{{dataObj.Consignee}}</p>
            </div>
            <div>
              <p>需要日期</p>
              <p>{{dataObj.RequiredDate}}</p>
            </div>
            <div>
              <p>销售产值</p>
              <p>￥{{dataObj.SalesAmount}}</p>
            </div>
            <div>
              <p>回款金额</p>
              <p>￥{{dataObj.PaybackAmount}}</p>
            </div>
            <div>
              <p>回款比例</p>
              <p>{{(dataObj.PaybackPercent*100)}}%</p>
            </div>
            <div>
              <p>回款说明</p>
              <p>{{dataObj.PaybackRemark}}</p>
            </div>
            <div>
              <p>未达到合同回款比例</p>
              <p>{{dataObj.OnetimesOffPayback? "是" : "否"}}</p>
            </div>
            <div>
              <p>出现两次以上不满足回款条件下单</p>
              <p>{{dataObj.TwotimesOffPayback? "是" : "否"}}</p>
            </div>

            <div>
              <p>备注内容</p>
              <p>{{dataObj.Remarks}}</p>
            </div>
            <div class="pic"
                 v-if="dataObj.Images">
              <p>相关附件</p>
              <div class="bg">
                <div v-for="(imgUrl,index) of dataObj.Images.split(',')"
                     :key="imgUrl"
                     :style="{backgroundImage:`url(${imgUrl})`}"
                     @click="$emit('showLargePic',dataObj.Images,index)"></div>
              </div>
            </div>
          </div>
          <div class="lgDetails-commont-title">
            <p>回复列表</p>
          </div>
          <div class="lgDetails-commont-list">
            <ul>
              <li v-for="(reply,index) of dataObj.Replies_OrdersModels"
                  :key="reply.Id">
                <div class="header">
                  <div class="headImage"
                       :style="{backgroundImage:`url(${reply.HeadImage})`}"></div>
                  <div class="info">
                    <p>{{reply.NickName}}</p>
                    <p>
                      <span>{{new Date(reply.CreatedTime) | myTimeago}}</span>
                      <span>举报</span>
                    </p>
                  </div>
                  <div class="reply">
                    <div></div>
                    <span @click="ReplyBoxShow[index] = !ReplyBoxShow[index]">回复</span>
                  </div>
                </div>
                <div class="content">
                  <p>{{reply.Contents}}</p>
                </div>
                <div class="replyBox"
                     v-show="ReplyBoxShow[index]">
                  <textarea placeholder="回复"
                            v-model="commentObj[index]"></textarea>
                  <div class="btn"
                       @click="quoteOrderReplies(reply.Id,index)">
                    <span>发送</span>
                  </div>
                </div>
                <div class="childReplies"
                     v-if="reply.ChildReplies.length > 0">
                  <p v-for="child in reply.ChildReplies"
                     :key="child.Id">
                    <span class="user">{{child.NickName}}</span>
                    <span>&nbsp;回复&nbsp;</span>
                    <span class="user">{{reply.NickName}}</span>
                    <span>&nbsp;：{{child.Contents}}</span>
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div class="lgDetails-send">
            <div>
              <input type="text"
                     placeholder="写下你的评论..."
                     v-model="comment" />
              <p class="sendBtn"
                 @click="addOrderReplies">发布</p>
              <p class="checkBtn"
                 @click="updateOrderState">通过审核</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template> 

<script>
import "../../../../../html/components/d-lgDetails/d-lgDetails.scss"

import timeago from '../../../../../pubilc/util/timeago'

import { GetLogisticInfo, AddOrderReplies, QuoteOrderReplies, UpdateOrderState } from '../../../../../api/index'


export default {
  name: 'd-lgDetails',
  data () {
    return {
      ReplyBoxShow: {},
      comment: '',
      commentObj: {},
      dataObj: {}
    }
  },
  props: {
    orderId: {
      type: Number
    },
    IsLogin: {
      type: Boolean
    }
  },
  methods: {
    async init () {
      let res = await GetLogisticInfo({
        id: this.orderId
      });
      // console.log(res);
      if (res.Type == "Success") {
        this.dataObj = res.Data;
        this.addProperty(this.dataObj.Replies_OrdersModels, this.ReplyBoxShow, false);
        this.addProperty(this.dataObj.Replies_OrdersModels, this.commentObj, '')
      }
    },
    addProperty (arr, obj, val) {
      arr.forEach((item, index) => {
        this.$set(obj, index, val);
      })
    },
    async addOrderReplies () {
      if (!this.IsLogin) {
        this.$layer.alert('您还未登录，请登录', (layerid) => {
          this.$layer.close(layerid);
          this.$login.show(1, userInfo => {
            this.setUserInfo(userInfo);
          });
        })
      } else {
        let res = await AddOrderReplies({
          collaborativeId: this.dataObj.Id,
          content: this.comment,
        });
        // console.log(res);
        if (res.Type == "Success") {
          this.$layer.alert(res.Content, (layerid) => {
            this.$layer.close(layerid);
            this.init();
            this.comment = '';
          })
        }
      }
    },
    async quoteOrderReplies (repId, index) {
      if (!this.IsLogin) {
        this.$layer.alert('您还未登录，请登录', (layerid) => {
          this.$layer.close(layerid);
          this.$login.show(1, userInfo => {
            this.setUserInfo(userInfo);
          });
        })
      } else {
        let res = await QuoteOrderReplies({
          collaborativeId: this.dataObj.Id,
          repId,
          content: this.commentObj[index]
        });
        // console.log(res)
        if (res.Type == "Success") {
          this.$layer.alert(res.Content, (layerid) => {
            this.$layer.close(layerid);
            this.init();
            this.subComment = '';
          })
        }
      }
    },
    async updateOrderState () {
      let res = await UpdateOrderState({
        Id: this.orderId,
        StatType: this.dataObj.OrderState
      });
      // console.log(res);
      if (res.Type == 'Success') {
        this.$layer.alert(res.Content, (layerid) => {
          this.$layer.close(layerid);
          this.$emit('closeLgD');
        })
      } else {
        this.$layer.alert(res.Content)
      }
    }
  },
  created () {
    this.init();
  },
  filters: {
    myTimeago (date) {
      return timeago(date)
    }
  }
}
</script>